import { Button, useRefresh, useNotify, useUnselectAll } from "react-admin";
import BlockIcon from "@material-ui/icons/Block";
import { useState } from "react";
import { firestore } from "../../../init/firebase";
import { useTheme } from "@material-ui/core";
import { applyTimestamps } from "../../../utils/funcs";

const DisablePropertyCompanyButton = ({ selectedIds }) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll();
  const [loading, setLoading] = useState();
  const theme = useTheme();
  const disableCourier = async () => {
    try {
      setLoading(true);
      const batch = firestore.batch();
      Array.isArray(selectedIds) &&
        selectedIds.forEach((id) => {
          batch.update(
            firestore.collection("propertiesCompanies").doc(id),
            applyTimestamps({
              data: {
                disabled: true,
              },
              isUpdate: true,
            })
          );
        });
      await batch.commit();
      notify("Companies have been updated", "success");
      unselectAll("propertiesCompanies");
      refresh();
      setLoading(false);
    } catch (ex) {
      console.log(ex.message);
      notify("Error on deleting companies", "error");
      refresh();
      setLoading(false);
    }
  };

  return (
    <Button style={{ color: theme.palette.error.main }} label="Disable" disabled={loading} onClick={disableCourier}>
      <BlockIcon color="error" />
    </Button>
  );
};

export default DisablePropertyCompanyButton;
